import React from "react";
import { Map_zoneUpload } from "./Map_zoneUpload";

export const ZoneMaps = () => {
  return <Map_zoneUpload />;
};
